<template>
    <div v-if="order">
        <template v-if="this.$vuetify.breakpoint.smAndDown">
            <!-- isMobile = true -->
            <div class="pa-4 my-2 car-history-element">
                <div class="font-weight-bold mb-2">Дата и время</div>
                <div class="mb-4">{{ dateFormatted }}</div>
                <!-- <div class="font-weight-bold mb-2">Цена</div>
                <div class="mb-4">{{ order.sum | currency }}</div> -->
                <div v-if="withCar" class="mb-4">
                    <div class="font-weight-bold mb-2">Автомобиль</div>
                    <div class="model">
                        {{ car.model }}, {{ car. yearManufacture }}
                    </div>
                    <div class="params">
                        <div class="numberPlate">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 8.66667V15.3333C21 15.7754 20.8259 16.1993 20.5161 16.5118C20.2062 16.8244 19.786 17 19.3478 17H3.65217C3.21399 17 2.79375 16.8244 2.48391 16.5118C2.17407 16.1993 2 15.7754 2 15.3333V8.66667C2 8.22464 2.17407 7.80072 2.48391 7.48816C2.79375 7.1756 3.21399 7 3.65217 7H19.3478C19.786 7 20.2062 7.1756 20.5161 7.48816C20.8259 7.80072 21 8.22464 21 8.66667ZM18.3478 15.3333C18.9001 15.3333 19.3478 14.8856 19.3478 14.3333V9.66667C19.3478 9.11438 18.9001 8.66667 18.3478 8.66667H4.65217C4.09989 8.66667 3.65217 9.11438 3.65217 9.66667V14.3333C3.65217 14.8856 4.09989 15.3333 4.65217 15.3333H18.3478Z" fill="#3fab3e"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 12C13 11.4477 12.4883 11 11.8571 11H6.14286C5.51167 11 5 11.4477 5 12C5 12.5523 5.51167 13 6.14286 13H11.8571C12.4883 13 13 12.5523 13 12Z" fill="#3fab3e"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.4477 14.597 11 15.3333 11H16.6667C17.403 11 18 11.4477 18 12C18 12.5523 17.403 13 16.6667 13H15.3333C14.597 13 14 12.5523 14 12Z" fill="#3fab3e"/>
                            </svg>
                            {{ car.numberPlate }}
                        </div>
                        <div class="mileage">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_819_2314)">
                                <path d="M12 0C5.38322 0 0 5.38322 0 12C0 18.6168 5.38322 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38322 18.6168 0 12 0ZM20.0408 19.192L18.364 17.5152L17.5156 18.3636L19.1924 20.0404C17.2816 21.7512 14.7664 22.8 12 22.8C9.23358 22.8 6.71841 21.7512 4.80759 20.0408L6.48441 18.364L5.63602 17.5156L3.9592 19.192C2.37398 17.4212 1.36959 15.1288 1.23042 12.6H3.6V11.4H1.23042C1.36964 8.87119 2.37441 6.57881 3.95963 4.80759L5.63644 6.48441L6.48483 5.63602L4.80802 3.9592C6.57881 2.37398 8.87123 1.36959 11.4 1.23042V3.6H12.6V1.23042C15.1288 1.36964 17.4212 2.37441 19.1924 3.95963L17.5156 5.63644L18.364 6.48483L20.0408 4.80802C21.626 6.57881 22.6304 8.87123 22.77 11.4004H20.4V12.6004H22.7696C22.6304 15.1288 21.626 17.4212 20.0408 19.192Z" fill="#3fab3e"/>
                                <path d="M12.5992 12.7103V7.19995H11.3992V12.7103C10.7024 12.9587 10.1992 13.6187 10.1992 14.4C10.1992 15.3923 11.0068 16.2 11.9992 16.2C12.9916 16.2 13.7992 15.3923 13.7992 14.4C13.7992 13.6187 13.296 12.9592 12.5992 12.7103ZM11.9992 15C11.668 15 11.3992 14.7312 11.3992 14.4C11.3992 14.0687 11.668 13.8 11.9992 13.8C12.3304 13.8 12.5992 14.0687 12.5992 14.4C12.5992 14.7312 12.3304 15 11.9992 15Z" fill="#3fab3e"/>
                                <path d="M15 19.2H9V20.4H15V19.2Z" fill="#3fab3e"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_819_2314">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            ~{{ order.mileage || order.probeg }} км
                        </div>
                    </div>
                </div>
                <div class="font-weight-bold mb-2">Номер документа</div>
                <div class="mb-4 text-red">{{ order.id }}</div>
                <template v-if="!withCar">
                    <div class="font-weight-bold mb-2">Пробег</div>
                    <div class="mb-4">~{{ order.mileage || order.probeg }} км</div>
                </template>
                <div class="font-weight-bold mb-2">Список услуг</div>
                <div v-if="order.works && order.works.length" class="selected-repairs mb-4">
                    <template v-for="(work, index) in order.works">
                        <div v-if="index < 2" :key="work.id" class="selected-repair">
                            <span v-if="index < 2">{{work.name}}</span>
                        </div>
                    </template>
                    <template v-if="order.works.length > 2">
                        <div v-if="order.works.length > 2" class="selected-repair" @click="showMore(order.works)">
                            {{`+ ${order.works.length - 2} услуг${ending(order.works.length - 2)}`}}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM8.71875 5.0625C8.88563 5.0625 9.04876 5.11199 9.18752 5.2047C9.32627 5.29741 9.43442 5.42919 9.49828 5.58336C9.56214 5.73754 9.57885 5.90719 9.54629 6.07086C9.51373 6.23453 9.43337 6.38487 9.31537 6.50287C9.19737 6.62087 9.04703 6.70123 8.88336 6.73379C8.71969 6.76634 8.55004 6.74963 8.39586 6.68577C8.24169 6.62191 8.10991 6.51377 8.0172 6.37501C7.92449 6.23626 7.875 6.07313 7.875 5.90625C7.875 5.68247 7.9639 5.46786 8.12213 5.30963C8.28037 5.15139 8.49498 5.0625 8.71875 5.0625ZM9.5625 12.9375C9.26414 12.9375 8.97799 12.819 8.76701 12.608C8.55603 12.397 8.4375 12.1109 8.4375 11.8125V9C8.28832 9 8.14525 8.94074 8.03976 8.83525C7.93427 8.72976 7.875 8.58668 7.875 8.4375C7.875 8.28832 7.93427 8.14524 8.03976 8.03975C8.14525 7.93426 8.28832 7.875 8.4375 7.875C8.73587 7.875 9.02202 7.99353 9.233 8.2045C9.44398 8.41548 9.5625 8.70163 9.5625 9V11.8125C9.71169 11.8125 9.85476 11.8718 9.96025 11.9773C10.0657 12.0827 10.125 12.2258 10.125 12.375C10.125 12.5242 10.0657 12.6673 9.96025 12.7727C9.85476 12.8782 9.71169 12.9375 9.5625 12.9375Z" fill="white"/>
                                <path d="M9.18751 5.2047C9.04876 5.11198 8.88563 5.0625 8.71875 5.0625C8.49497 5.0625 8.28036 5.15139 8.12213 5.30963C7.93631 5.50176 7.875 5.6885 7.875 5.90625C7.875 6.07313 7.92448 6.23626 8.0172 6.37501C8.10991 6.51377 8.24169 6.62191 8.39586 6.68577C8.55004 6.74963 8.71969 6.76634 8.88336 6.73379C9.04703 6.70123 9.19737 6.62087 9.31537 6.50287C9.43337 6.38487 9.51373 6.23453 9.54629 6.07086C9.56705 5.66988 9.47821 5.47507 9.18751 5.2047Z" fill="#3fab3e"/>
                                <path d="M8.76701 12.608C8.97798 12.819 9.26413 12.9375 9.5625 12.9375C9.71168 12.9375 9.85476 12.8782 9.96025 12.7727C10.0657 12.6673 10.125 12.5242 10.125 12.375C10.125 12.2258 10.0657 12.0827 9.96025 11.9773C9.85476 11.8718 9.71168 11.8125 9.5625 11.8125V9C9.5625 8.70163 9.44397 8.41548 9.23299 8.2045C9.02665 7.97688 8.85284 7.90417 8.4375 7.875C8.28832 7.875 8.14524 7.93426 8.03975 8.03975C7.93426 8.14524 7.875 8.28832 7.875 8.4375C7.875 8.58668 7.93426 8.72976 8.03975 8.83525C8.14524 8.94074 8.28832 9 8.4375 9V11.8125C8.4375 12.1109 8.55603 12.397 8.76701 12.608Z" fill="#3fab3e"/>
                            </svg>
                        </div>
                    </template>
                </div>
                <div class="font-weight-bold mb-2">Товары</div>
                <div v-if="order.items && order.items.length" class="selected-repairs mb-4">
                    <template v-for="(item, index) in order.items">
                        <div v-if="index < 2" :key="`${item.name}-${index}`" class="selected-repair">
                            <span v-if="index < 2">{{item.name}}</span>
                        </div>
                    </template>
                    <template v-if="order.items.length > 2">
                        <div v-if="order.items.length > 2" class="selected-repair" @click="showMoreItems(order.items)">
                            {{`+ ${order.items.length - 2} товаров${ending(order.items.length - 2)}`}}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM8.71875 5.0625C8.88563 5.0625 9.04876 5.11199 9.18752 5.2047C9.32627 5.29741 9.43442 5.42919 9.49828 5.58336C9.56214 5.73754 9.57885 5.90719 9.54629 6.07086C9.51373 6.23453 9.43337 6.38487 9.31537 6.50287C9.19737 6.62087 9.04703 6.70123 8.88336 6.73379C8.71969 6.76634 8.55004 6.74963 8.39586 6.68577C8.24169 6.62191 8.10991 6.51377 8.0172 6.37501C7.92449 6.23626 7.875 6.07313 7.875 5.90625C7.875 5.68247 7.9639 5.46786 8.12213 5.30963C8.28037 5.15139 8.49498 5.0625 8.71875 5.0625ZM9.5625 12.9375C9.26414 12.9375 8.97799 12.819 8.76701 12.608C8.55603 12.397 8.4375 12.1109 8.4375 11.8125V9C8.28832 9 8.14525 8.94074 8.03976 8.83525C7.93427 8.72976 7.875 8.58668 7.875 8.4375C7.875 8.28832 7.93427 8.14524 8.03976 8.03975C8.14525 7.93426 8.28832 7.875 8.4375 7.875C8.73587 7.875 9.02202 7.99353 9.233 8.2045C9.44398 8.41548 9.5625 8.70163 9.5625 9V11.8125C9.71169 11.8125 9.85476 11.8718 9.96025 11.9773C10.0657 12.0827 10.125 12.2258 10.125 12.375C10.125 12.5242 10.0657 12.6673 9.96025 12.7727C9.85476 12.8782 9.71169 12.9375 9.5625 12.9375Z" fill="white"/>
                                <path d="M9.18751 5.2047C9.04876 5.11198 8.88563 5.0625 8.71875 5.0625C8.49497 5.0625 8.28036 5.15139 8.12213 5.30963C7.93631 5.50176 7.875 5.6885 7.875 5.90625C7.875 6.07313 7.92448 6.23626 8.0172 6.37501C8.10991 6.51377 8.24169 6.62191 8.39586 6.68577C8.55004 6.74963 8.71969 6.76634 8.88336 6.73379C9.04703 6.70123 9.19737 6.62087 9.31537 6.50287C9.43337 6.38487 9.51373 6.23453 9.54629 6.07086C9.56705 5.66988 9.47821 5.47507 9.18751 5.2047Z" fill="#3fab3e"/>
                                <path d="M8.76701 12.608C8.97798 12.819 9.26413 12.9375 9.5625 12.9375C9.71168 12.9375 9.85476 12.8782 9.96025 12.7727C10.0657 12.6673 10.125 12.5242 10.125 12.375C10.125 12.2258 10.0657 12.0827 9.96025 11.9773C9.85476 11.8718 9.71168 11.8125 9.5625 11.8125V9C9.5625 8.70163 9.44397 8.41548 9.23299 8.2045C9.02665 7.97688 8.85284 7.90417 8.4375 7.875C8.28832 7.875 8.14524 7.93426 8.03975 8.03975C7.93426 8.14524 7.875 8.28832 7.875 8.4375C7.875 8.58668 7.93426 8.72976 8.03975 8.83525C8.14524 8.94074 8.28832 9 8.4375 9V11.8125C8.4375 12.1109 8.55603 12.397 8.76701 12.608Z" fill="#3fab3e"/>
                            </svg>
                        </div>
                    </template>
                </div>
                <div v-if="!withoutComment">
                    <v-btn
                        class="block-change feedback-btn"
                        elevation="0"
                        :to="{ name: 'HistoryFeedback', params: { orderId: order.id } }"
                    >
                        Оставить отзыв
                    </v-btn>
                </div>
                <div v-if="withCancelBtn">
                    <v-btn
                        block
                        class="block-change feedback-btn"
                        elevation="0"
                        :loading="isCanceling" @click="showCancelDialogMobile = true"
                    >
                        Отменить заказ
                    </v-btn>
                </div>
            </div>
            <v-bottom-sheet
                v-model="showMoreWorks"
                title="Список услуг">
                <v-card tile class="more-works-dialog-card">
                    <v-toolbar
                        flat
                    >
                        <v-toolbar-title><span class="font-weight-bold">Список услуг</span></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="showMoreWorks = false"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.75 5.25L5.25 18.75" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.75 18.75L5.25 5.25" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="moreWorks && moreWorks.length" class="selected-repairs">
                            <template v-for="(work) in moreWorks">
                                <div :key="work.id" class="selected-repair">
                                    <span>{{work.name}}</span>
                                </div>
                            </template>
                        </div>
                    </v-card-text>
                </v-card>
            </v-bottom-sheet>
            <v-bottom-sheet
                v-model="isShowMoreItems"
                title="Список товаров">
                <v-card tile class="more-works-dialog-card">
                    <v-toolbar
                        flat
                    >
                        <v-toolbar-title><span class="font-weight-bold">Список товаров</span></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="isShowMoreItems = false"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.75 5.25L5.25 18.75" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.75 18.75L5.25 5.25" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="moreWorksItems && moreWorksItems.length" class="selected-repairs">
                            <template v-for="(item, index) in moreWorksItems">
                                <div :key="`${item.name}-${index}`" class="selected-repair">
                                    <span>{{item.name}}</span>
                                </div>
                            </template>
                        </div>
                    </v-card-text>
                </v-card>
            </v-bottom-sheet>
        </template>
        <template v-else>
            <!-- isMobile = false -->
            <div class="history-table-item mt-2 d-flex px-6">
                <div class="pr-2" style="width: 12%">{{ dateFormatted }}</div>
                <div class="px-2 text-red" style="width: 20%">{{ order.id }}</div>
                <div v-if="withCar" style="width:20%">
                    <div class="model">
                        {{ car.model }}, {{ car. yearManufacture }}
                    </div>
                    <div class="params">
                        <div class="numberPlate">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 8.66667V15.3333C21 15.7754 20.8259 16.1993 20.5161 16.5118C20.2062 16.8244 19.786 17 19.3478 17H3.65217C3.21399 17 2.79375 16.8244 2.48391 16.5118C2.17407 16.1993 2 15.7754 2 15.3333V8.66667C2 8.22464 2.17407 7.80072 2.48391 7.48816C2.79375 7.1756 3.21399 7 3.65217 7H19.3478C19.786 7 20.2062 7.1756 20.5161 7.48816C20.8259 7.80072 21 8.22464 21 8.66667ZM18.3478 15.3333C18.9001 15.3333 19.3478 14.8856 19.3478 14.3333V9.66667C19.3478 9.11438 18.9001 8.66667 18.3478 8.66667H4.65217C4.09989 8.66667 3.65217 9.11438 3.65217 9.66667V14.3333C3.65217 14.8856 4.09989 15.3333 4.65217 15.3333H18.3478Z" fill="#3fab3e"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 12C13 11.4477 12.4883 11 11.8571 11H6.14286C5.51167 11 5 11.4477 5 12C5 12.5523 5.51167 13 6.14286 13H11.8571C12.4883 13 13 12.5523 13 12Z" fill="#3fab3e"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.4477 14.597 11 15.3333 11H16.6667C17.403 11 18 11.4477 18 12C18 12.5523 17.403 13 16.6667 13H15.3333C14.597 13 14 12.5523 14 12Z" fill="#3fab3e"/>
                            </svg>
                            {{ car.numberPlate }}
                        </div>
                        <div class="mileage">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_819_2314)">
                                <path d="M12 0C5.38322 0 0 5.38322 0 12C0 18.6168 5.38322 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38322 18.6168 0 12 0ZM20.0408 19.192L18.364 17.5152L17.5156 18.3636L19.1924 20.0404C17.2816 21.7512 14.7664 22.8 12 22.8C9.23358 22.8 6.71841 21.7512 4.80759 20.0408L6.48441 18.364L5.63602 17.5156L3.9592 19.192C2.37398 17.4212 1.36959 15.1288 1.23042 12.6H3.6V11.4H1.23042C1.36964 8.87119 2.37441 6.57881 3.95963 4.80759L5.63644 6.48441L6.48483 5.63602L4.80802 3.9592C6.57881 2.37398 8.87123 1.36959 11.4 1.23042V3.6H12.6V1.23042C15.1288 1.36964 17.4212 2.37441 19.1924 3.95963L17.5156 5.63644L18.364 6.48483L20.0408 4.80802C21.626 6.57881 22.6304 8.87123 22.77 11.4004H20.4V12.6004H22.7696C22.6304 15.1288 21.626 17.4212 20.0408 19.192Z" fill="#3fab3e"/>
                                <path d="M12.5992 12.7103V7.19995H11.3992V12.7103C10.7024 12.9587 10.1992 13.6187 10.1992 14.4C10.1992 15.3923 11.0068 16.2 11.9992 16.2C12.9916 16.2 13.7992 15.3923 13.7992 14.4C13.7992 13.6187 13.296 12.9592 12.5992 12.7103ZM11.9992 15C11.668 15 11.3992 14.7312 11.3992 14.4C11.3992 14.0687 11.668 13.8 11.9992 13.8C12.3304 13.8 12.5992 14.0687 12.5992 14.4C12.5992 14.7312 12.3304 15 11.9992 15Z" fill="#3fab3e"/>
                                <path d="M15 19.2H9V20.4H15V19.2Z" fill="#3fab3e"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_819_2314">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            ~{{ order.mileage || order.probeg }} км
                        </div>
                    </div>
                </div>
                <div v-else style="width:10%">
                    <div class="font-weight-bold mb-2">~{{ order.mileage || order.probeg || 0 }} км</div>
                </div>
                <div class="px-2" style="width: 40%">
                    <div v-if="order.works && order.works.length" class="selected-repairs">
                        <template v-for="(work, index) in order.works">
                            <div v-if="index < 3" :key="work.id" class="selected-repair">
                                <span v-if="index < 3">{{work.name}}</span>
                            </div>
                        </template>
                        <template v-if="order.works.length > 3">
                            <v-tooltip bottom color="#FFFFFF">
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-if="order.works.length > 3" class="selected-repair" v-on="on" v-bind="attrs">
                                        {{`+ ${order.works.length - 3} услуг${ending(order.works.length - 3)}`}}
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM8.71875 5.0625C8.88563 5.0625 9.04876 5.11199 9.18752 5.2047C9.32627 5.29741 9.43442 5.42919 9.49828 5.58336C9.56214 5.73754 9.57885 5.90719 9.54629 6.07086C9.51373 6.23453 9.43337 6.38487 9.31537 6.50287C9.19737 6.62087 9.04703 6.70123 8.88336 6.73379C8.71969 6.76634 8.55004 6.74963 8.39586 6.68577C8.24169 6.62191 8.10991 6.51377 8.0172 6.37501C7.92449 6.23626 7.875 6.07313 7.875 5.90625C7.875 5.68247 7.9639 5.46786 8.12213 5.30963C8.28037 5.15139 8.49498 5.0625 8.71875 5.0625ZM9.5625 12.9375C9.26414 12.9375 8.97799 12.819 8.76701 12.608C8.55603 12.397 8.4375 12.1109 8.4375 11.8125V9C8.28832 9 8.14525 8.94074 8.03976 8.83525C7.93427 8.72976 7.875 8.58668 7.875 8.4375C7.875 8.28832 7.93427 8.14524 8.03976 8.03975C8.14525 7.93426 8.28832 7.875 8.4375 7.875C8.73587 7.875 9.02202 7.99353 9.233 8.2045C9.44398 8.41548 9.5625 8.70163 9.5625 9V11.8125C9.71169 11.8125 9.85476 11.8718 9.96025 11.9773C10.0657 12.0827 10.125 12.2258 10.125 12.375C10.125 12.5242 10.0657 12.6673 9.96025 12.7727C9.85476 12.8782 9.71169 12.9375 9.5625 12.9375Z" fill="white"/>
                                            <path d="M9.18751 5.2047C9.04876 5.11198 8.88563 5.0625 8.71875 5.0625C8.49497 5.0625 8.28036 5.15139 8.12213 5.30963C7.93631 5.50176 7.875 5.6885 7.875 5.90625C7.875 6.07313 7.92448 6.23626 8.0172 6.37501C8.10991 6.51377 8.24169 6.62191 8.39586 6.68577C8.55004 6.74963 8.71969 6.76634 8.88336 6.73379C9.04703 6.70123 9.19737 6.62087 9.31537 6.50287C9.43337 6.38487 9.51373 6.23453 9.54629 6.07086C9.56705 5.66988 9.47821 5.47507 9.18751 5.2047Z" fill="#3fab3e"/>
                                            <path d="M8.76701 12.608C8.97798 12.819 9.26413 12.9375 9.5625 12.9375C9.71168 12.9375 9.85476 12.8782 9.96025 12.7727C10.0657 12.6673 10.125 12.5242 10.125 12.375C10.125 12.2258 10.0657 12.0827 9.96025 11.9773C9.85476 11.8718 9.71168 11.8125 9.5625 11.8125V9C9.5625 8.70163 9.44397 8.41548 9.23299 8.2045C9.02665 7.97688 8.85284 7.90417 8.4375 7.875C8.28832 7.875 8.14524 7.93426 8.03975 8.03975C7.93426 8.14524 7.875 8.28832 7.875 8.4375C7.875 8.58668 7.93426 8.72976 8.03975 8.83525C8.14524 8.94074 8.28832 9 8.4375 9V11.8125C8.4375 12.1109 8.55603 12.397 8.76701 12.608Z" fill="#3fab3e"/>
                                        </svg>
                                    </div>
                                </template>
                                <v-card class="pa-4">
                                    <div v-if="order.works && order.works.length" class="selected-repairs">
                                        <template v-for="(work, index) in order.works">
                                            <div v-if="index > 2" :key="work.id" class="selected-repair">
                                                <span v-if="index > 2">{{work.name}}</span>
                                            </div>
                                        </template>
                                    </div>
                                </v-card>
                            </v-tooltip>
                        </template>
                    </div>
                </div>
                <!-- <div class="px-2" style="width: 13%">{{ order.sum | currency }}</div> -->
                <template v-if="!withoutComment">
                    <div class="step-action" v-if="withCar">
                        <v-btn
                            icon
                            elevation="0"
                            class="block-change"
                            style="margin-left: 10px; width: 44px; height: 44px; padding: 0;"
                            :to="{ name: 'HistoryFeedback', params: { orderId: order.id } }"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_517_2925)">
                                <path d="M9.96844 18.3638C9.90176 18.2528 9.80748 18.1609 9.69478 18.0972C9.58207 18.0334 9.45479 18 9.32531 18H3.75C3.55109 18 3.36032 17.921 3.21967 17.7803C3.07902 17.6397 3 17.4489 3 17.25V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H20.25C20.4489 4.5 20.6397 4.57902 20.7803 4.71967C20.921 4.86032 21 5.05109 21 5.25V17.25C21 17.4489 20.921 17.6397 20.7803 17.7803C20.6397 17.921 20.4489 18 20.25 18H14.6747C14.5452 18 14.4179 18.0334 14.3052 18.0972C14.1925 18.1609 14.0982 18.2528 14.0316 18.3638L12.6431 20.6362C12.5765 20.7473 12.4822 20.8392 12.3695 20.903C12.2568 20.9668 12.1295 21.0004 12 21.0004C11.8705 21.0004 11.7432 20.9668 11.6305 20.903C11.5178 20.8392 11.4235 20.7473 11.3569 20.6362L9.96844 18.3638Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9 9.75H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9 12.75H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_517_2925">
                                <rect width="24" height="24" fill="currentColor"/>
                                </clipPath>
                                </defs>
                            </svg>

                        </v-btn>
                    </div>
                    <div v-else class="step-action">
                        <v-btn
                            icon
                            elevation="0"
                            class="block-change"
                            style="margin-left: 10px; width: 44px; height: 44px; padding: 0;"
                            :to="{ name: 'HistoryFeedback', params: { orderId: order.id } }"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_517_2925)">
                                <path d="M9.96844 18.3638C9.90176 18.2528 9.80748 18.1609 9.69478 18.0972C9.58207 18.0334 9.45479 18 9.32531 18H3.75C3.55109 18 3.36032 17.921 3.21967 17.7803C3.07902 17.6397 3 17.4489 3 17.25V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H20.25C20.4489 4.5 20.6397 4.57902 20.7803 4.71967C20.921 4.86032 21 5.05109 21 5.25V17.25C21 17.4489 20.921 17.6397 20.7803 17.7803C20.6397 17.921 20.4489 18 20.25 18H14.6747C14.5452 18 14.4179 18.0334 14.3052 18.0972C14.1925 18.1609 14.0982 18.2528 14.0316 18.3638L12.6431 20.6362C12.5765 20.7473 12.4822 20.8392 12.3695 20.903C12.2568 20.9668 12.1295 21.0004 12 21.0004C11.8705 21.0004 11.7432 20.9668 11.6305 20.903C11.5178 20.8392 11.4235 20.7473 11.3569 20.6362L9.96844 18.3638Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9 9.75H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9 12.75H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_517_2925">
                                <rect width="24" height="24" fill="currentColor"/>
                                </clipPath>
                                </defs>
                            </svg>

                        </v-btn>
                    </div>
                </template>
                <template v-if="withCancelBtn">
                    <div class="step-action" v-if="withCar">
                        <v-btn
                            icon
                            elevation="0"
                            class="block-change"
                            style="margin-left: 10px; width: 44px; height: 44px; padding: 0;"
                            :loading="isCanceling" @click="showCancelDialog = true"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_517_6542)">
                                <path d="M20.25 5.25H3.75" stroke="#DA251C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.75 9.75V15.75" stroke="#DA251C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.25 9.75V15.75" stroke="#DA251C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25" stroke="#DA251C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25" stroke="#DA251C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_517_6542">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn
                            class="block-change feedback-btn"
                            elevation="0"
                            :loading="isCanceling" @click="showCancelDialog = true"
                        >
                            Отменить заказ
                        </v-btn>
                    </div>
                </template>
            </div>
        </template>
        <v-dialog v-model="showCancelDialog" width="490">
            <v-card class="delete-dialog pl-10 pr-5 pb-10 pt-3">
                <div class="d-flex justify-end">
                    <v-btn
                        icon
                        small
                        @click="showCancelDialog = false"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 5.25L5.25 18.75" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.75 18.75L5.25 5.25" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                    </v-btn>
                </div>
                <div>
                    <div class="header">Отменить запись?</div>
                </div>
                <div class="pt-4">
                    <p>Вы собираетесь отменить запись</p> <p>на {{dateFormatted}}</p>
                </div>
                <div class="pt-2 pr-5 d-flex align-center justify-space-between">
                    <div class="step-action">
                        <v-btn
                            @click="cancelOrder"
                            elevation="0"
                        >
                            Отменить запись
                        </v-btn>
                    </div>
                    <div class="step-action cancel">
                        <v-btn
                            @click="showCancelDialog = false"
                            elevation="0"
                        >
                            Закрыть
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-bottom-sheet v-model="showCancelDialogMobile">
            <v-card class="delete-dialog pl-4 pr-2 pb-4 pt-2">
                <div class="d-flex justify-end">
                    <v-btn
                        icon
                        small
                        @click="showCancelDialogMobile = false"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 5.25L5.25 18.75" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.75 18.75L5.25 5.25" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                    </v-btn>
                </div>
                <div>
                    <div class="header">Отменить запись?</div>
                </div>
                <div class="pt-4">
                    <p>Вы собираетесь отменить запись</p> <p>на {{dateFormatted}}</p>
                </div>
                <div class="pt-2 pr-2">
                    <div class="step-action">
                        <v-btn
                            @click="cancelOrder"
                            elevation="0"
                        >
                            Отменить запись
                        </v-btn>
                    </div>
                    <div class="step-action cancel pt-2">
                        <v-btn
                            @click="showCancelDialogMobile = false"
                            elevation="0"
                        >
                            Закрыть
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import moment from 'moment'
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'OrderHistoryItem',

        components: {
            //
        },

        props: {
            order: { type: Object },
            car: { type: Object },
            withCar: { type: Boolean, default: false },
            withoutComment: { type: Boolean, default: false },
            withCancelBtn: { type: Boolean, default: false },
        },

        data() {
            return {
                showMoreWorks: false,
                isShowMoreItems: false,
                moreWorks: [],
                moreWorksItems: [],
                showCancelDialog: false,
                showCancelDialogMobile: false,
            }
        },

        computed: {
            ...mapGetters({
                getQuestionsByDate: 'feedback/getQuestionsByDate',
            }),
            ...mapState('order', {
                isCanceling: (state) => state.isCanceling,
            }),

            dateFormatted() {
                const unix = this.order?.date

                if (unix) {
                    return moment.unix(unix).utcOffset(5).locale('ru').format('LLL')
                } else {
                    return null
                }
            },

            questions() {
                return this.getQuestionsByDate(this.order?.date)
            },
        },

        methods: {
            ending(count) {
                if (count > 4 && count < 21) {
                    return ''
                }
                const lastDigit = count % 10
                if (lastDigit === 1) {
                    return 'а'
                }
                if (lastDigit > 1 && lastDigit < 5) {
                    return 'и'
                }
                return ''
            },

            showMore(works) {
                this.moreWorks = works.slice(2)
                this.showMoreWorks = true
            },

            hideMore() {
                this.moreWorks = []
                this.showMoreWorks = false
            },

            showMoreItems(items) {
                this.moreWorksItems = items.slice(2)
                this.isShowMoreItems = true
            },

            hideMoreItems() {
                this.moreWorksItems = []
                this.isShowMoreItems = false
            },

            cancelOrder() {
                const orderId = this.order?.id
                const orderDate = this.order?.date

                this.$store.dispatch('order/cancelOrder', {
                    orderId,
                    orderDate,
                })
                    .then(() => {
                        this.showCancelDialog = false
                        this.showCancelDialogMobile = false
                        this.$store.dispatch('order/fetch')
                    })
                    .catch(() => {
                        this.showCancelDialog = false
                        this.showCancelDialogMobile = false
                        //
                    })
            },
        },
    }
</script>

<style scoped>
    .selected-repairs {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }
    .mobile .selected-repairs {
        margin-left: 0;
        gap: 6px;
        flex-wrap: wrap;
    }
    .selected-repair {
        display: flex;
        padding: 5px 16px;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border-radius: 24px;
        border: 1px solid #F3F4F4;
        background: #F3F4F4;
        color: #36393B;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
        white-space: nowrap;
    }
    .mobile .selected-repair {
        padding: 4px 10px 5px 10px;
        white-space: nowrap;
    }
    .mobile .selected-repair span {
        max-width: 80vw;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .feedback-btn::before {
        opacity: 0 !important;
    }
    .mobile .car-history-element {
        border-radius: 12px;
        border: 1px solid #F3F4F4;
    }
    .more-works-dialog-card {
        width: 100vw;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        min-height: 40vh;
        border-radius: 12px !important;
    }
    .numberPlate {
        min-width: 126px;
        font-size: 14px;
    }
    .params {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 8px;
    }
    .params div{
        display: flex;
        padding: 8px 14px;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
        border-radius: 24px;
        border: 1px solid #F3F4F4;
        background: #F3F4F4;
    }
    .mobile .params div {
        width: fit-content;
        padding-right: 14px;
    }
    .step-action {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .step-action .v-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 2px solid #DA251C !important;
        background: #FFF !important;
        width: 253px;
        height: 52px;
        color: #DA251C;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .step-action .v-btn:hover {
        border: 2px solid #DA251C !important;
        background: #DA251C !important;
        color: #FFF;
    }
    .text-red {
        color: #DA251C;
        font-weight: 600;
        text-decoration: underline dotted #DA251C;
        text-underline-offset: 4px;
    }
    .block-change {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 1.5px solid #DA251C;
        /* width: 165px; */
        height: 52px;
        background: #fff !important;
        color: #DA251C !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .step-action.cancel .v-btn {
        background-color: #F3F4F4 !important;
        color: #36393B !important;
        border: #36393B !important;
        width: 146px;
    }
</style>
